<template>
    <main class="white-card-query">
        <header class="page-header">
            <button
                type="button"
                aria-label="返回"
                title="返回"
                @click="goHome"
            >
                <van-icon name="arrow-left" />
            </button>
            <h1>号码查询</h1>
            <span></span>
        </header>

        <section v-if="!result" class="query-form">
            <div class="section-title">
                <span class="title-icon"><van-icon name="search" /></span>
                <div>
                    <h2>查询开卡进度</h2>
                    <p>输入开户姓名和完整身份证号码</p>
                </div>
            </div>

            <div class="field-group">
                <label class="field-label" for="customerName">开户姓名</label>
                <div class="input-shell">
                    <van-icon name="contact" />
                    <input
                        id="customerName"
                        v-model.trim="customerName"
                        maxlength="30"
                        placeholder="请输入开户人姓名"
                    />
                    <button
                        v-if="customerName"
                        type="button"
                        aria-label="清空姓名"
                        title="清空"
                        @click="customerName = ''"
                    >
                        <van-icon name="clear" />
                    </button>
                </div>
            </div>

            <div class="field-group">
                <label class="field-label" for="identityCode">身份证号码</label>
                <div class="input-shell">
                    <van-icon name="certificate" />
                    <input
                        id="identityCode"
                        v-model.trim="identityCode"
                        inputmode="text"
                        maxlength="18"
                        placeholder="请输入完整身份证号码"
                        @input="normalizeIdentityCode"
                    />
                    <button
                        v-if="identityCode"
                        type="button"
                        aria-label="清空身份证号码"
                        title="清空"
                        @click="identityCode = ''"
                    >
                        <van-icon name="clear" />
                    </button>
                </div>
            </div>

            <button
                class="primary-button"
                type="button"
                :disabled="loading"
                @click="handleQuery"
            >
                <van-loading v-if="loading" size="18" color="#fff" />
                <span v-else>立即查询</span>
            </button>
        </section>

        <section v-else class="query-result">
            <div class="result-heading">
                <div>
                    <p>最新办理状态</p>
                    <h2>{{ result.status }}</h2>
                </div>
                <span class="status-icon"><van-icon name="exchange" /></span>
            </div>

            <div class="summary-list">
                <div>
                    <span>开户姓名</span
                    ><strong>{{ maskName(result.customerName) }}</strong>
                </div>
                <div v-if="result.serviceId">
                    <span>办理号码</span
                    ><strong>{{ maskPhone(result.serviceId) }}</strong>
                </div>
                <div v-if="result.iccid">
                    <span>ICCID</span><strong>{{ result.iccid }}</strong>
                </div>
                <div v-if="result.packageName">
                    <span>办理套餐</span
                    ><strong>{{ result.packageName }}</strong>
                </div>
            </div>

            <section class="record-section">
                <div class="record-title">
                    <h3>办理记录</h3>
                    <span>共 {{ result.records.length }} 条</span>
                </div>
                <article
                    v-for="item in result.records"
                    :key="item.key"
                    class="record-item"
                >
                    <div class="record-header">
                        <div class="record-event">
                            <span
                                class="record-dot"
                                :class="item.statusType"
                            ></span>
                            <strong>{{ item.applyEvent }}</strong>
                        </div>
                        <span class="status-badge" :class="item.statusType">{{
                            item.status
                        }}</span>
                    </div>

                    <div
                        v-if="item.serviceId || item.packageName"
                        class="record-meta"
                    >
                        <span v-if="item.serviceId"
                            >号码 {{ maskPhone(item.serviceId) }}</span
                        >
                        <span v-if="item.packageName">{{
                            item.packageName
                        }}</span>
                    </div>

                    <time v-if="item.acceptDate">
                        <van-icon name="clock-o" />
                        <span>受理时间 {{ item.acceptDate }}</span>
                    </time>

                    <div
                        v-if="item.ifValid || item.auditRemark"
                        class="record-message"
                    >
                        <p v-if="item.ifValid">
                            <van-icon name="info-o" />{{ item.ifValid }}
                        </p>
                        <p v-if="item.auditRemark">
                            <van-icon name="comment-o" />审核备注：{{
                                item.auditRemark
                            }}
                        </p>
                    </div>
                </article>
            </section>

            <button class="secondary-button" type="button" @click="resetQuery">
                <van-icon name="replay" />
                <span>查询其他号码</span>
            </button>
        </section>

        <button
            class="service-fab"
            type="button"
            aria-label="联系客服"
            title="联系客服"
            @click="contactService"
        >
            <img src="@/assets/images/whiteCard/logo.png" alt="" />
        </button>
        <WhiteCardCustomerService v-model="showCustomerService" />
    </main>
</template>

<script>
import { Toast } from "vant"
import { OtaCheckOpenPhoneWork } from "@/common/newapi/api.js"
import { getWhiteCardRoute } from "./whiteCardRoute"
import WhiteCardCustomerService from "./WhiteCardCustomerService.vue"

export default {
    name: "WhiteCardQuery",
    components: {
        WhiteCardCustomerService,
    },
    data() {
        return {
            customerName: "",
            identityCode: "",
            loading: false,
            result: null,
            showCustomerService: false,
        }
    },
    methods: {
        goHome() {
            this.$router.push(getWhiteCardRoute("/WhiteCardHome", this.$route))
        },
        normalizeIdentityCode() {
            this.identityCode = String(this.identityCode || "")
                .replace(/[^0-9Xx]/g, "")
                .toUpperCase()
                .slice(0, 18)
        },
        async handleQuery() {
            const customerName = this.customerName.trim()
            if (!customerName) {
                Toast({ message: "请输入开户人姓名", position: "bottom" })
                return
            }
            if (!/^\d{17}[\dX]$/.test(this.identityCode)) {
                Toast({
                    message: "请输入正确的18位身份证号码",
                    position: "bottom",
                })
                return
            }

            this.loading = true
            try {
                const response = await OtaCheckOpenPhoneWork({
                    customerName,
                    identityCode: this.identityCode,
                })
                const result = this.unwrapResponse(response)
                if (!result || !["0", "1"].includes(String(result.code))) {
                    Toast({
                        message:
                            (result && result.msg) ||
                            "开卡进度查询失败，请重试",
                        position: "bottom",
                    })
                    return
                }

                const records = Array.isArray(result.data)
                    ? result.data
                    : result.data
                    ? [result.data]
                    : []
                if (!records.length) {
                    Toast({
                        message: result.msg || "未查询到开卡记录",
                        position: "bottom",
                    })
                    return
                }
                this.result = this.normalizeQueryResult(records)
            } catch (error) {
                if (!error || !error.response) {
                    Toast({
                        message: "开卡进度查询失败，请重试",
                        position: "bottom",
                    })
                }
            } finally {
                this.loading = false
            }
        },
        resetQuery() {
            this.customerName = ""
            this.identityCode = ""
            this.result = null
        },
        unwrapResponse(response) {
            if (
                response &&
                response.data &&
                (response.status !== undefined ||
                    response.config ||
                    response.headers)
            ) {
                return response.data
            }
            return response
        },
        normalizeQueryResult(records) {
            const source = records[0] || {}
            const normalizedRecords = records.map((item, index) =>
                this.normalizeRecord(item, index)
            )
            return {
                customerName:
                    source.customerName ||
                    source.userName ||
                    source.name ||
                    this.customerName,
                serviceId:
                    source.serviceId ||
                    source.phoneNumber ||
                    source.phone ||
                    source.mobile ||
                    "",
                iccid: source.iccid || source.cardNo || source.simCardNo || "",
                packageName:
                    source.prodOfferName ||
                    source.packageName ||
                    source.offerName ||
                    "",
                status: normalizedRecords[0].status,
                records: normalizedRecords,
            }
        },
        normalizeRecord(item, index) {
            const source = item || {}
            const status =
                source.status ||
                source.statusName ||
                source.statusDesc ||
                "处理中"
            const statusText = String(status)
            let statusType = "pending"
            if (/不通过|失败|驳回|拒绝|异常/.test(statusText)) {
                statusType = "failed"
            } else if (/通过|成功|完成/.test(statusText)) {
                statusType = "success"
            }
            return {
                key:
                    source.id ||
                    `${source.serviceId || "record"}-${
                        source.acceptDate || index
                    }-${index}`,
                applyEvent:
                    source.applyEvent || source.eventName || "开卡业务办理",
                status,
                statusType,
                acceptDate: this.formatDateTime(
                    source.acceptDate || source.createTime || source.updateTime
                ),
                serviceId:
                    source.serviceId ||
                    source.phoneNumber ||
                    source.phone ||
                    "",
                packageName:
                    source.prodOfferName ||
                    source.packageName ||
                    source.offerName ||
                    source.prodOfferId ||
                    "",
                ifValid: source.ifValid || "",
                auditRemark: source.auditRemark || "",
            }
        },
        formatDateTime(value) {
            if (value === undefined || value === null || value === "") return ""
            if (typeof value === "string" && !/^\d+$/.test(value)) return value
            const timestamp = Number(value)
            const date = new Date(
                timestamp < 100000000000 ? timestamp * 1000 : timestamp
            )
            if (Number.isNaN(date.getTime())) return String(value)
            const pad = number => String(number).padStart(2, "0")
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
                date.getDate()
            )} ${pad(date.getHours())}:${pad(date.getMinutes())}`
        },
        maskPhone(value) {
            return String(value || "").replace(
                /(\d{3})\d{4}(\d{4})/,
                "$1****$2"
            )
        },
        maskName(value) {
            const name = String(value || "")
            if (name.length <= 1) return name
            return `${name.slice(0, 1)}${"*".repeat(name.length - 1)}`
        },
        contactService() {
            this.showCustomerService = true
        },
    },
}
</script>

<style scoped lang="scss">
.white-card-query {
    --primary: #f4511e;
    --primary-dark: #c62828;
    --primary-soft: #fff0ec;
    --coral: #ff7043;
    --ink: #2a2336;
    --muted: #6e6678;
    --line: #f3ddd7;
    --line-strong: #eecbc2;
    width: 100%;
    max-width: 480px;
    min-height: 100vh;
    margin: 0 auto;
    padding-bottom: 80px;
    color: var(--ink);
    background: #fff;
    position: relative;
}

.page-header {
    height: 58px;
    padding: 0 16px;
    display: grid;
    grid-template-columns: 40px 1fr 40px;
    align-items: center;
    background: #fff;
    border-bottom: 1px solid var(--line);

    button {
        width: 36px;
        height: 36px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: var(--ink);
        background: transparent;
        font-size: 20px;
    }

    h1 {
        text-align: center;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0;
    }
}

.query-form,
.query-result {
    padding: 30px 18px;
}

.section-title {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 32px;

    h2 {
        font-size: 21px;
        line-height: 28px;
        letter-spacing: 0;
    }

    p {
        margin-top: 4px;
        color: var(--muted);
        font-size: 13px;
        line-height: 19px;
    }
}

.title-icon {
    width: 48px;
    height: 48px;
    flex: 0 0 48px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: linear-gradient(135deg, #ff7043, var(--primary));
    border-radius: 14px;
    font-size: 24px;
}

.field-label {
    display: block;
    margin: 0 2px 8px;
    font-size: 14px;
    font-weight: 600;
}

.field-group + .field-group {
    margin-top: 18px;
}

.input-shell {
    height: 54px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    gap: 10px;
    background: #fff;
    border: 1px solid var(--line-strong);
    border-radius: 14px;

    > .van-icon {
        color: var(--primary);
        font-size: 20px;
    }

    input {
        min-width: 0;
        flex: 1;
        color: var(--ink);
        font-size: 15px;
    }

    button {
        width: 30px;
        height: 30px;
        color: #adb3c1;
        background: transparent;
        font-size: 17px;
    }
}

.primary-button,
.secondary-button {
    width: 100%;
    height: 50px;
    margin-top: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #fff;
    background: linear-gradient(135deg, #ff7043, var(--primary));
    border-radius: 18px;
    box-shadow: 0 10px 24px rgba(244, 81, 30, 0.24);
    font-size: 16px;
    font-weight: 600;
}

.primary-button:disabled {
    opacity: 0.6;
}

.result-heading {
    min-height: 112px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    background: linear-gradient(135deg, #ff7043, var(--primary));
    border-radius: 18px;
    box-shadow: 0 12px 28px rgba(244, 81, 30, 0.22);

    p {
        color: rgba(255, 255, 255, 0.88);
        font-size: 13px;
    }

    h2 {
        margin-top: 6px;
        font-size: 28px;
        line-height: 34px;
        letter-spacing: 0;
    }
}

.status-icon {
    width: 52px;
    height: 52px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--primary);
    background: #fff;
    border-radius: 50%;
    font-size: 27px;
}

.summary-list {
    margin-top: 14px;
    padding: 6px 16px;
    background: #fff;
    border: 1px solid var(--line);
    border-radius: 18px;

    div {
        min-height: 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        border-bottom: 1px solid var(--line);
        font-size: 13px;

        &:last-child {
            border-bottom: 0;
        }
    }

    span {
        color: var(--muted);
    }

    strong {
        min-width: 0;
        text-align: right;
        overflow-wrap: anywhere;
    }
}

.record-section {
    margin-top: 22px;
}

.record-title {
    margin-bottom: 10px;
    padding: 0 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
        font-size: 17px;
        line-height: 24px;
    }

    span {
        color: var(--muted);
        font-size: 12px;
    }
}

.record-item {
    padding: 16px;
    background: #fff;
    border: 1px solid var(--line);
    border-radius: 8px;

    + .record-item {
        margin-top: 12px;
    }
}

.record-header,
.record-event,
.record-item time {
    display: flex;
    align-items: center;
}

.record-header {
    justify-content: space-between;
    gap: 12px;
}

.record-event {
    min-width: 0;
    gap: 9px;

    strong {
        min-width: 0;
        font-size: 15px;
        line-height: 22px;
        overflow-wrap: anywhere;
    }
}

.record-dot {
    width: 10px;
    height: 10px;
    flex: 0 0 10px;
    background: var(--primary);
    border-radius: 50%;
    box-shadow: 0 0 0 4px var(--primary-soft);

    &.success {
        background: #22a06b;
        box-shadow: 0 0 0 4px #e7f7ef;
    }

    &.failed {
        background: #df3b45;
        box-shadow: 0 0 0 4px #fdebed;
    }
}

.status-badge {
    flex: 0 0 auto;
    padding: 4px 9px;
    color: #b54708;
    background: #fff3e8;
    border-radius: 10px;
    font-size: 12px;
    line-height: 18px;

    &.success {
        color: #137a4d;
        background: #e7f7ef;
    }

    &.failed {
        color: #b4232c;
        background: #fdebed;
    }
}

.record-meta {
    margin-top: 13px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px 16px;
    color: var(--ink);
    font-size: 13px;
    line-height: 20px;
}

.record-item time {
    margin-top: 10px;
    gap: 6px;
    color: var(--muted);
    font-size: 12px;
    line-height: 18px;
}

.record-message {
    margin-top: 12px;
    padding: 10px 12px;
    color: #5e4b3d;
    background: #fff8f1;
    border-left: 3px solid #ff7043;
    border-radius: 4px;

    p {
        display: flex;
        align-items: flex-start;
        gap: 6px;
        font-size: 12px;
        line-height: 19px;

        + p {
            margin-top: 5px;
        }
    }

    .van-icon {
        flex: 0 0 auto;
        margin-top: 3px;
        color: var(--primary);
    }
}

.secondary-button {
    color: var(--primary-dark);
    background: #fff;
    border: 1px solid #f6b8aa;
    box-shadow: none;
}

.service-fab {
    width: 46px;
    height: 46px;
    position: absolute;
    right: 16px;
    bottom: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--primary);
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 8px 20px rgba(180, 55, 30, 0.22),
        0 0 0 1px rgba(244, 81, 30, 0.15);

    img {
        width: 38px;
        height: 38px;
        border-radius: 50%;
    }
}
</style>
